// Generated by purs version 0.15.4
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Formatter_DateTime from "../Data.Formatter.DateTime/index.js";
import * as Data_Formatter_Number from "../Data.Formatter.Number/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_List from "../Data.List/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Number_Format from "../Data.Number.Format/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as PartyCarlo_Data_Probability from "../PartyCarlo.Data.Probability/index.js";
var fold = /* #__PURE__ */ Data_Foldable.fold(Data_Foldable.foldableArray)(Data_Monoid.monoidString);
var bindFlipped = /* #__PURE__ */ Control_Bind.bindFlipped(Control_Bind.bindArray);
var displayString = {
    display: /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn)
};
var displayNumber = {
    display: /* #__PURE__ */ Data_Show.show(Data_Show.showNumber)
};
var displayMilliseconds = {
    display: function (v) {
        return Data_Number_Format.toStringWith(Data_Number_Format.fixed(0))(v) + "ms";
    }
};
var displayInt = {
    display: /* #__PURE__ */ (function () {
        var commaIntFmt = {
            comma: true,
            before: 0,
            after: 0,
            abbreviations: false,
            sign: false
        };
        var $22 = Data_Formatter_Number.format(commaIntFmt);
        return function ($23) {
            return $22(Data_Int.toNumber($23));
        };
    })()
};
var displayDateTime = /* #__PURE__ */ (function () {
    return {
        display: Data_Formatter_DateTime.format(Data_List.fromFoldable(Data_Foldable.foldableArray)([ Data_Formatter_DateTime.YearAbsolute.value, new Data_Formatter_DateTime.Placeholder("-"), Data_Formatter_DateTime.MonthTwoDigits.value, new Data_Formatter_DateTime.Placeholder("-"), Data_Formatter_DateTime.DayOfMonthTwoDigits.value, new Data_Formatter_DateTime.Placeholder(" "), Data_Formatter_DateTime.Hours24.value, new Data_Formatter_DateTime.Placeholder(":"), Data_Formatter_DateTime.MinutesTwoDigits.value, new Data_Formatter_DateTime.Placeholder(":"), Data_Formatter_DateTime.SecondsTwoDigits.value, new Data_Formatter_DateTime.Placeholder(":"), Data_Formatter_DateTime.Milliseconds.value ]))
    };
})();
var display = function (dict) {
    return dict.display;
};
var displayArray = function (dictDisplay) {
    var display1 = display(dictDisplay);
    return {
        display: function (xs) {
            var elems = fold(Data_Maybe.fromMaybe([  ])(Data_Array.init(bindFlipped(function (elem) {
                return [ display1(elem), ", " ];
            })(xs))));
            return "[" + (elems + "]");
        }
    };
};
var displayProbability = {
    display: /* #__PURE__ */ (function () {
        var $24 = display(displayNumber);
        return function ($25) {
            return $24(PartyCarlo_Data_Probability.toNumber($25));
        };
    })()
};
var displayTuple = function (dictDisplay) {
    var display1 = display(dictDisplay);
    return function (dictDisplay1) {
        var display2 = display(dictDisplay1);
        return {
            display: function (v) {
                return fold([ "(", display1(v.value0), ",", display2(v.value1), ")" ]);
            }
        };
    };
};
export {
    display,
    displayString,
    displayDateTime,
    displayInt,
    displayMilliseconds,
    displayTuple,
    displayProbability,
    displayNumber,
    displayArray
};
